import React from 'react';
import { clientFormFields, useClientForm } from './ClientData';
import './index.scss';

const ClientForm = ({ formData, errors, onChange, onChangeMultiple, onBlur, onSubmit, onCancel, setErrors, isSubmitting }) => {
  const { handleSubmit, renderField } = useClientForm(
    formData,
    errors,
    onChange,
    onChangeMultiple,
    onBlur,
    onSubmit,
    setErrors,
    isSubmitting
  );

  return (
    <form onSubmit={handleSubmit} className="client-form">
      <div className="form-container">
        {clientFormFields.map((field) => renderField(field))}
      </div>

      <div className="form-actions">
        <button
          type="button"
          className="btn-cancel"
          onClick={onCancel}
          disabled={isSubmitting}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="btn-submit"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Creating...' : 'Create New'}
        </button>
      </div>
    </form>
  );
};

export default ClientForm;